import React from 'react';
import { observer } from 'mobx-react';
import { Selected } from 'libs/forms/styles';
import Tooltip from 'components/Tooltip';

export const BreadCrumbsSelection = observer(({ selected, fieldStore }) => {
  const {
    conf: { labelKey },
  } = fieldStore;
  // const displayApp = showOptions ? highlighted || selected : selected;
  const displayApp = selected;
  let tooltip = null;
  const displayVal = displayApp[labelKey];
  if (displayApp.getPath) {
    const displayApps = displayApp.getPath.map(app => app[labelKey]);
    tooltip = displayApps.join(' > ');
  }
  return (
    <>
      <Tooltip delayShow={200} place='bottom' id='selectionTtooltip' />
      <Selected data-for='selectionTtooltip' data-tip={tooltip}>
        {displayVal}
      </Selected>
    </>
  );
});
